import Vue from 'vue';
import Router from 'vue-router';
import { component } from 'vue/types/umd';

// 引入所有路由组件
// import Layout from '@/components/Layout.vue'; // 引入 Layout 组件
const Index = () => import('@/views/Index/Index.vue');
const NotFound = () => import('@/views/Error/Index.vue');
// ...其他路由组件
const Layout = () => import('@/components/Layout.vue');
const IndexLayout = () => import('@/components/IndexLayout.vue');
const SearchLayout = () => import('@/components/SearchLayout.vue');
//注册DOI
const UserRegister = () => import('@/views/Register/User.vue');
//付费独立注册DOI
const MemberRegister = () => import('@/views/Register/Member.vue');
//会员申请
const MemberApply = () => import('@/views/Register/MemberApply.vue');
//帮助
//如何开始
const Start = () => import('@/views/Help/Start.vue');
//如何注册DOI
const Register = () => import('@/views/Help/Register.vue');
//如何查询
const Query = () => import('@/views/Help/Query.vue');
//如何统计
const Statistics = () => import('@/views/Help/Statistics.vue');
//自动化接口
const Automation = () => import('@/views/Help/Automation.vue');
//常见问题
const Question = () => import('@/views/Help/Question.vue');

//图书馆 
//图书馆会员说明
const Explain = () => import('@/views/Library/Explain.vue');
// 图书馆会员规则
const Rule = () => import('@/views/Library/Rule.vue');
//申请图书馆会员资格
const Apply = () => import('@/views/Library/Apply.vue');
//查询服务
const LibraryQueryService = () => import('@/views/Library/QueryService.vue');
//DOI与馆藏资源整合
const Merge = () => import('@/views/Library/Merge.vue');
//DOI与OpenURL
const OpenURL = () => import('@/views/Library/OpenURL.vue');

//合作伙伴
const PartneList = () => import('@/views/Partner/List.vue');
//合作伙伴说明
const PartneExplain = () => import('@/views/Partner/Explain.vue');
//合作伙伴费用
const PartneCharge = () => import('@/views/Partner/Charge.vue');
// 合作伙伴规则
const PartneRule = () => import('@/views/Partner/Rule.vue');
// 第三方平台接口
const PartnePlatforms = () => import('@/views/Partner/Platforms.vue');

// 出版机构
//出版机构说明
const PublishingAgencyExplain = () => import('@/views/PublishingAgency/Explain.vue');
//出版机构费用
const PublishingAgencyCharge = () => import('@/views/PublishingAgency/Charge.vue');

//出版机构规则
const PublishingAgencyRule = () => import('@/views/PublishingAgency/Rule.vue');
//申请出版机构会员
const PublishingAgencyApply = () => import('@/views/PublishingAgency/Apply.vue');
//电子书DOI
const Ebook = () => import('@/views/PublishingAgency/Ebook.vue');
//科学数据DOI
const ScientificData = () => import('@/views/PublishingAgency/ScientificData.vue');
//Crossref代理服务
const Crossre = () => import('@/views/PublishingAgency/Crossre.vue');
//查询服务
const QueryService = () => import('@/views/PublishingAgency/QueryService.vue');
//多重解析
const MultipleAnalyze = () => import('@/views/PublishingAgency/MultipleAnalyze.vue');

//资源中心


//技术文档
const Document = () => import('@/views/ResourceCenter/Document.vue');
//演示样例
const Example = () => import('@/views/ResourceCenter/Example.vue');
//工具软件
const Tool = () => import('@/views/ResourceCenter/Tool.vue');
//业界动态
const Trends = () => import('@/views/ResourceCenter/Trends.vue');
//高级检索

const QueryComplex = () => import('@/views/Query/Complex.vue');
//检索结果
const SearchDoi = () => import('@/views/Query/SearchDoi.vue');

//检索期刊列表

const Journal = () => import('@/views/Query/Journal.vue');

//查看DOI注册统计

const Doisum = () => import('@/views/Query/Doisum.vue');

//查看DOI解析统计
const ParseStat = () => import('@/views/Query/ParseStat.vue');

//业界动态详情
const detail = () => import('@/views/ResourceCenter/industryDetails.vue');

//多重解析详情
const analyzeDetails = () => import('@/views/PublishingAgency/analysisDetails.vue');

//声明更多
const LearnMore = () => import('@/views/Index/LearnMore.vue');

//科学数据查询
const SearchScienceData = () => import('@/views/PublishingAgency/SearchScienceData.vue');

// 注册 Vue Router
Vue.use(Router);

// 创建路由器实例
const router = new Router({
  mode: 'history', // 使用 HTML5 History 模式
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: IndexLayout,
      meta: { title: '首页' },
      children: [
        {
          path: '', // 子路由的路径可以是空字符串，表示根路径
          name: 'Index',
          component: Index,
        },
      ],
    },
    {
      //高级检索
      path: '/queryComplex',
      name: 'queryComplex',
      component: IndexLayout, // 组件
      children: [
        {
          path: '',
          name: 'queryComplex',
          meta: { title: '高级检索' },
          component: QueryComplex
        }
      ]
    },
    {
      //检索结果
      path: '/searchDoi',
      name: 'searchDoi',
      component: SearchLayout, // 组件
      children: [
        {
          path: '',
          name: 'searchDoi',
          meta: { title: '检索结果' },
          component: SearchDoi
        }
      ]
    },
    {
      //检索期刊列表
      path: '/analyse',
      name: 'Journal',
      redirect: '/analyse/journal', // 重定向到 'Journal' 子路由
      component: Layout, // 组件
      children: [
        {
          path: 'journal',
          name: 'Journal',
          meta: { title: '检索期刊列表' },
          component: Journal
        },
        {
          path: 'doisum',
          name: 'Doisum',
          meta: { title: '查看DOI注册统计' },
          component: Doisum
        },
        {
          path: 'doiparse',
          name: 'parseStat',
          meta: { title: '查看DOI解析统计' },
          component: ParseStat
        }
      ]
    },
    {
      //查看DOI注册统计
      path: '/doisum',
      name: 'Doisum',
      redirect: '/analyse/doisum',
      component: Layout, // 组件
    },
    { //查看DOI解析统计
      path: '/doiparse',
      name: 'parseStat',
      redirect: '/analyse/doiparse',
      component: Layout, // 组件
    },
    {
      path: '/registeruser',
      name: 'userRegister',
      component: Layout, // 组件
      children: [
        {
          path: '',
          name: 'UserRegister',
          meta: { title: '万方免费注册doi' },
          component: UserRegister
        }
      ]
    },
    {
      path: '/member',
      name: 'member',
      component: Layout, // 组件
      children: [
        {
          path: '',
          name: 'MemberRegister',
          meta: { title: '付费独立注册doi' },
          component: MemberRegister
        },
        {
          path: 'apply',
          name: 'MemberApply',
          meta: { title: '会员申请' },
          component: MemberApply
        }
      ]
    },
    {
      //
      path: '/publisher',
      redirect: '/publisher/explain', // 重定向到 'explain' 子路由
      name: 'publisher',
      meta: { title: '出版机构' },
      component: Layout,
      children: [
        {//出版机构说明
          path: 'explain',
          name: 'PublishingAgencyExplain',
          meta: { title: '出版机构说明' },
          component: PublishingAgencyExplain,
        },
        {//出版机构费用
          path: 'charge',
          name: 'PublishingAgencyCharge',
          meta: { title: '出版机构费用' },
          component: PublishingAgencyCharge,
        },
        {//出版机构规则
          path: 'rule',
          name: 'PublishingAgencyRule',
          meta: { title: '出版机构规则' },
          component: PublishingAgencyRule,
        },
        {//申请出版机构会员
          path: 'apply',
          name: 'PublishingAgencyApply',
          meta: { title: '申请出版机构会员' },
          component: PublishingAgencyApply,
        },

        {//电子书DOI
          path: 'ebook',
          name: 'Ebook',
          meta: { title: '电子书DOI' },
          component: Ebook,
        },
        {//科学数据DOI
          path: 'scientificdata',
          name: 'ScientificData',
          meta: { title: '科学数据DOI' },
          component: ScientificData,
        },
        {//Crossref代理服务
          path: 'crossre',
          name: 'Crossre',
          meta: { title: 'Crossref代理服务' },
          component: Crossre,
        },
        {//查询服务
          path: 'queryservice',
          name: 'QueryService',
          meta: { title: '查询服务' },
          component: QueryService,
        },
        {//多重解析
          path: 'multipleanalyze',
          name: 'MultipleAnalyze',
          meta: { title: '多重解析' },
          component: MultipleAnalyze,
        },
      ]
    },
    {
      path: '/library',
      redirect: '/library/explain',
      component: Layout,
      name: 'library',
      meta: { title: '图书馆' },
      children: [
        {//图书馆会员说明
          path: 'explain',
          name: 'Explain',
          meta: { title: '图书馆会员说明' },
          component: Explain,
        },
        {//图书馆会员规则
          path: 'rule',
          name: 'Rule',
          meta: { title: '图书馆会员规则' },
          component: Rule,
        },
        {//申请图书馆会员资格
          path: 'apply',
          name: 'Apply',
          meta: { title: '申请图书馆会员资格' },
          component: Apply,
        },
        {//查询服务
          path: 'queryservice',
          name: 'LibraryQueryService',
          meta: { title: '查询服务' },
          component: LibraryQueryService,
        },
        {//DOI与馆藏资源整合
          path: 'merge',
          name: 'Merge',
          meta: { title: 'DOI与馆藏资源整合' },
          component: Merge,
        },
        {//DOI与OpenURL
          path: 'openurl',
          name: 'OpenURL',
          meta: { title: 'DOI与OpenURL' },
          component: OpenURL,
        }
      ]
    },
    {
      //合作伙伴
      path: '/partner',
      redirect: '/partner/list',
      name: 'partner',
      component: Layout,
      meta: { title: '合作伙伴' },
      children: [
        {
          //合作伙伴列表
          path: 'list',
          name: 'partnelist',
          meta: { title: '合作伙伴列表' },
          component: PartneList,
        },
        {//合作伙伴说明
          path: 'explain',
          name: 'partneexplain',
          meta: { title: '合作伙伴说明' },
          component: PartneExplain,
        },
        {//合作伙伴收费
          path: 'charge',
          name: 'PartneCharge',
          meta: { title: '合作伙伴费用' },
          component: PartneCharge,
        },
        {//合作伙伴规则
          path: 'rule',
          name: 'PartneRule',
          meta: { title: '合作伙伴规则' },
          component: PartneRule,
        },
        {//第三方平台接口
          path: 'platforms',
          name: 'PartnePlatforms',
          meta: { title: '第三方平台接口' },
          component: PartnePlatforms,
        },
      ]
    },
    {
      path: '/help',
      redirect: '/help/start',
      component: Layout,
      name: 'help',
      meta: { title: '帮助' },
      children: [
        {//如何注册DOI
          path: 'start',
          name: 'start',
          meta: { title: '如何开始' },
          component: Start,
        },
        {//如何注册DOI
          path: 'register',
          name: 'Register',
          meta: { title: '如何注册DOI' },
          component: Register,
        },
        {//如何查询
          path: 'query',
          name: 'Query',
          meta: { title: '如何查询' },
          component: Query,
        },
        {//如何统计
          path: 'statistics',
          name: 'Statistics',
          meta: { title: '如何统计' },
          component: Statistics,
        },
        {//自动化接口
          path: 'automation',
          name: 'Automation',
          meta: { title: '自动化接口' },
          component: Automation,
        },
        {//常见问题
          path: 'question',
          name: 'Question',
          meta: { title: '常见问题' },
          component: Question,
        },
      ],
    },
    //资源中心
    {
      path: '/resourcecenter',
      redirect: '/resourcecenter/document',
      component: Layout,
      name: 'resourcecenter',
      meta: { title: '资源中心' },
      children: [
        {//技术文档
          path: 'document',
          name: 'document',
          meta: { title: '技术文档' },
          component: Document,
        },
        {//演示样例
          path: 'example',
          name: 'example',
          meta: { title: '演示样例' },
          component: Example,
        },
        {//工具软件
          path: 'tool',
          name: 'tool',
          meta: { title: '工具软件' },
          component: Tool,
        },
        {//业界动态
          path: 'trends',
          name: 'trends',
          meta: { title: '业界动态' ,keepAlive: true},
          component: Trends,
        },
      ]
    },
    {
      path: '/portal',
      redirect: '/portal/detail',
      component: IndexLayout,
      children: [
        {//业界动态详情
          path: 'detail',
          name: 'industryDetails',
          meta: { title: '详情' },
          component: detail,
        },
      ]
    },
    {//需要和旧版本统一路由
      path: '/portal',
      redirect: '/portal/mr.action',
      component: Layout,
      children: [
        {//多重解析详情
          path: 'mr.action',//子路由path不加斜杠
          name: 'portal',
          meta: { title: '多重解析' },
          component: analyzeDetails,
        },
      ]
    },
    {//了解更多
      path: '/learnmore',
      component: Layout,
      children: [
        {
          path: '',//子路由path不加斜杠
          name: 'learnmore',
          meta: { title: '机构介绍' },
          component: LearnMore,
        },
      ]
    },
    {//科学数据DOI查询
      path: '/searchsciencedata',
      component: Layout,
      children: [
        {
          path: '',//子路由path不加斜杠
          name: '科学数据DOI查询',
          meta: { title: '科学数据DOI查询' },
          component: SearchScienceData,
        },
      ]
    }

    // {// 404页面路由
    //   path: '*',
    //   component: Layout,
    //   children: [
    //     {
    //       path: '',
    //       name: 'NotFound',
    //       component: NotFound,
    //     },
    //   ],
    // } 
    // ...其他路由配置
  ],
});
/**
 * 解决点击同一个路由报错问题
*/
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return (originalPush.call(this, location) as any).catch(err => err)
}
const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location) {
  return (originalReplace.call(this, location) as any).catch(err => err)
}


export default router;